import React from 'react'
import { StaticQuery, graphql } from 'gatsby'
import PaginatorNavigationRender from './PaginatorNavigationRender'
const PaginatorNavigation = props => (
	<StaticQuery
		query={graphql`
			query {
				importJson {
					spreads {
						uid
					}
				}
			}
		`}
		render={data => (
			<React.Fragment>
				<PaginatorNavigationRender
					arr={data.importJson.spreads}
					baseSlug="documents"
					tilePrefix={props.tilePrefix}
				/>
			</React.Fragment>
		)}
	/>
)
export default PaginatorNavigation
